import React from 'react';
import { LegalLayout } from './LegalLayout';
import { THtml } from '../../components/Translate';

const PRIVACY_HTML = `
<p>En <strong>PlanCity</strong> respetamos tu privacidad y protegemos tus datos personales conforme a la <strong>Ley N° 19.628 sobre Protección de la Vida Privada</strong> y la nueva <strong>Ley N° 21.719</strong> que la moderniza, así como a los demás cuerpos legales aplicables en Chile. Esta política explica cómo recopilamos, utilizamos, almacenamos y compartimos tu información.</p>

<div class="legal-callout">Si tienes alguna duda o quieres ejercer tus derechos (acceso, rectificación, cancelación, oposición y portabilidad), escríbenos a través de nuestro <a href="/contacto">formulario de contacto</a>. Responderemos dentro del plazo legal aplicable.</div>

<h2>1. Responsable del Tratamiento</h2>
<p>El responsable del tratamiento de tus datos personales es <strong>PlanCity</strong>, con domicilio en Antofagasta, Chile. Para contactar al responsable usa nuestro <a href="/contacto">formulario de contacto</a>.</p>

<h2>2. Datos que Recopilamos</h2>
<ul>
  <li><strong>Datos de identificación</strong>: nombre, correo electrónico, teléfono (cuando lo entregas).</li>
  <li><strong>Datos de cuenta y autenticación</strong>: hash de contraseña, rol, fecha de registro, último ingreso.</li>
  <li><strong>Datos de proveedor</strong>: razón social, RUT, descripción, redes sociales, logos y fotos cargadas voluntariamente.</li>
  <li><strong>Datos de uso</strong>: páginas visitadas, eventos consultados, comuna seleccionada, filtros aplicados, dirección IP, tipo de dispositivo y navegador.</li>
  <li><strong>Datos de transacciones</strong>: plan contratado, fecha y monto (no almacenamos números completos de tarjeta de crédito; estos son procesados por nuestros proveedores de pago).</li>
  <li><strong>Comunicaciones</strong>: mensajes que envías a través del formulario de contacto o a proveedores.</li>
</ul>

<h2>3. Bases de Licitud</h2>
<p>Tratamos tus datos en virtud de:</p>
<ul>
  <li><strong>Consentimiento</strong>, otorgado al registrarte o al aceptar las cookies.</li>
  <li><strong>Ejecución de un contrato</strong> (por ejemplo, gestionar tu plan de suscripción).</li>
  <li><strong>Interés legítimo</strong>, para mejorar la Plataforma, prevenir fraudes y entregar un servicio relevante.</li>
  <li><strong>Cumplimiento legal</strong>, cuando la ley nos obligue (por ejemplo, requerimientos del SII o autoridades judiciales).</li>
</ul>

<h2>4. Finalidades del Tratamiento</h2>
<ul>
  <li>Permitirte registrarte, iniciar sesión y usar la Plataforma.</li>
  <li>Mostrar eventos cercanos según tu comuna y preferencias.</li>
  <li>Procesar pagos y entregar funcionalidades premium (Stripe u otros proveedores).</li>
  <li>Enviar notificaciones operativas (cambios de plan, vencimiento de trial, mensajes recibidos).</li>
  <li>Enviar comunicaciones de marketing solo si has dado consentimiento expreso, con derecho a oposición en cada envío.</li>
  <li>Detectar y prevenir abusos, fraudes o usos no autorizados.</li>
  <li>Cumplir obligaciones legales, contables y tributarias.</li>
</ul>

<h2>5. Compartición con Terceros</h2>
<p>Compartimos datos únicamente con encargados que prestan servicios a PlanCity, bajo acuerdos de confidencialidad y tratamiento de datos:</p>
<ul>
  <li><strong>Hosting y bases de datos</strong>: proveedores cloud para almacenar la Plataforma.</li>
  <li><strong>Imágenes</strong>: ImgBB para alojar fotografías subidas por proveedores.</li>
  <li><strong>Pagos</strong>: Stripe u otros procesadores autorizados por la CMF.</li>
  <li><strong>Comunicaciones</strong>: proveedores de email transaccional (ej. SendGrid/Resend) y/o WhatsApp (CallMeBot) solo para notificaciones operativas internas.</li>
  <li><strong>Mapas</strong>: OpenStreetMap / Leaflet para mostrar ubicaciones.</li>
  <li><strong>Autoridades</strong>: cuando exista requerimiento judicial o legal.</li>
</ul>
<p>No vendemos ni alquilamos tus datos personales a terceros con fines publicitarios.</p>

<h2>6. Transferencias Internacionales</h2>
<p>Algunos proveedores (hosting, ImgBB, Stripe) pueden almacenar datos fuera de Chile. Garantizamos que dichas transferencias se realizan a proveedores con estándares de seguridad equivalentes a los exigidos por la legislación chilena.</p>

<h2>7. Plazo de Conservación</h2>
<p>Conservamos tus datos mientras tu cuenta esté activa y por el plazo necesario para cumplir las obligaciones legales que nos sean aplicables (por ejemplo, obligación tributaria de 6 años). Cuando eliminas tu cuenta, anonimizamos o suprimimos los datos personales en un plazo máximo de 30 días, salvo aquellos que debamos conservar por ley.</p>

<h2>8. Tus Derechos (Habeas Data)</h2>
<p>Conforme a la Ley N° 19.628 y la Ley N° 21.719 tienes derecho a:</p>
<ul>
  <li><strong>Acceso</strong>: saber qué datos tuyos tratamos.</li>
  <li><strong>Rectificación</strong>: corregir datos inexactos o incompletos.</li>
  <li><strong>Cancelación / Supresión</strong>: solicitar la eliminación de tus datos.</li>
  <li><strong>Oposición</strong>: oponerte a tratamientos específicos, como marketing.</li>
  <li><strong>Portabilidad</strong>: recibir tus datos en formato estructurado.</li>
  <li><strong>Bloqueo</strong>: solicitar el bloqueo temporal mientras se resuelve una controversia.</li>
  <li><strong>Reclamo</strong>: ante la <strong>Agencia de Protección de Datos Personales</strong> (autoridad de control prevista por la Ley N° 21.719) o, mientras esta no se constituya plenamente, ante los tribunales civiles competentes y/o el SERNAC.</li>
</ul>

<h2>9. Seguridad</h2>
<ul>
  <li>Las contraseñas se almacenan con hashing bcrypt.</li>
  <li>Las comunicaciones entre tu navegador y nuestros servidores viajan cifradas mediante TLS/HTTPS.</li>
  <li>Realizamos respaldos periódicos y aplicamos controles de acceso por roles.</li>
  <li>Aplicamos el principio de minimización de datos: solo solicitamos lo necesario.</li>
</ul>

<h2>10. Cookies</h2>
<p>Utilizamos cookies y tecnologías similares conforme a nuestra <a href="/cookies">Política de Cookies</a>. Puedes configurar tu navegador para rechazarlas, aunque algunas funcionalidades pueden verse afectadas.</p>

<h2>11. Menores de Edad</h2>
<p>La Plataforma está dirigida a mayores de 18 años. Si tomamos conocimiento de que hemos tratado datos de un menor sin autorización del representante legal, eliminaremos dicha información a la brevedad.</p>

<h2>12. Cambios a esta Política</h2>
<p>Podremos actualizar esta política para reflejar mejoras o cambios legales. La fecha de la última actualización siempre estará visible al inicio. Los cambios sustanciales serán informados por correo o mediante un aviso destacado en la Plataforma.</p>

<h2>13. Contacto</h2>
<p>Para ejercer tus derechos o consultas: usa nuestro <a href="/contacto">formulario de contacto</a>.</p>
`;

export const Privacy = () => {
  return (
    <LegalLayout
      title="Política de Privacidad"
      lastUpdated="18 de mayo de 2026"
      path="/privacidad"
      description="Política de Privacidad de PlanCity. Cómo recopilamos, usamos y protegemos tus datos personales conforme a la Ley N° 19.628 y Ley N° 21.719 de Chile."
    >
      <THtml html={PRIVACY_HTML} />
    </LegalLayout>
  );
};

export default Privacy;
